/**
 * Navigeren en bellen gaan buiten de app om (README §Schermen E2) en werken dus offline.
 * Zonder coördinaten navigeert de app op adres.
 */

function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (/Mac/.test(ua) && navigator.maxTouchPoints > 1);
}

export interface Destination {
  lat: number | null;
  lng: number | null;
  label: string;
  addressLine: string;
  postalCodeCity: string;
}

export function hasCoordinates(destination: Destination): boolean {
  return (
    typeof destination.lat === 'number' &&
    typeof destination.lng === 'number' &&
    Number.isFinite(destination.lat) &&
    Number.isFinite(destination.lng)
  );
}

export function navigationHref(destination: Destination, apple: boolean = isApplePlatform()): string {
  const address = `${destination.addressLine}, ${destination.postalCodeCity}`.trim();
  if (hasCoordinates(destination)) {
    const coords = `${destination.lat!},${destination.lng!}`;
    return apple
      ? `https://maps.apple.com/?daddr=${encodeURIComponent(coords)}&q=${encodeURIComponent(destination.label)}`
      : `geo:${coords}?q=${encodeURIComponent(`${coords}(${destination.label})`)}`;
  }
  return apple
    ? `https://maps.apple.com/?daddr=${encodeURIComponent(address)}`
    : `geo:0,0?q=${encodeURIComponent(address)}`;
}

/** Normaliseert een opgeslagen nummer ("030 604 18 22") naar een bruikbare `tel:`-href. */
export function telHref(phone: string): string {
  const cleaned = phone.replace(/[^\d+]/g, '');
  return `tel:${cleaned}`;
}

export function openExternal(href: string): void {
  if (typeof window === 'undefined') return;
  window.location.href = href;
}
